module.exports = __webpack_public_path__ + "img/Visits.facbfa38.jpg";